import {
  coohomHeaders,
  DefTypes,
  qunheHeaders,
  requestPerformancePrefix,
} from '../../constants';
import { IResponseHandlerData } from '../../types';
import ErrorParser from '../../utils/errorParser';
import {
  canIUseFeature,
  checkIfNeedCollect,
  formatUrl,
  getDocOrigin,
  getOrigin,
  getTraceId,
  getType,
  isEmptyObj,
} from '../../utils/func';
import logger from '../../utils/logger';
import SystemOptions from '../../utils/options';
import { handleErrorResponse, handleSuccessResponse } from '../../utils/responseHandler';
import { processErrorDataV2 } from '../collector';

function checkStatus(response: Response, configs: Pick<IResponseHandlerData, 'url' | 'data' | 'method' | 'traceId'>) {
  const { status } = response;
  const { url, data, method, traceId } = configs;
  const handleData = {
    url,
    data,
    apiType: 'fetch',
    statusCode: status,
    method,
    traceId,
    async: true,
  } as IResponseHandlerData;

  if ((status >= 200 && status < 300) || status === 304) {
    handleSuccessResponse(handleData);
  } else {
    handleErrorResponse(handleData);
  }

  return response;
}

export default function() {
  const options = SystemOptions.getInstance().getOptions();

  if (canIUseFeature(!!fetch) && options.initPagePerformance && options.getAjaxPerformance) {
    const { performanceStartPrefix } = requestPerformancePrefix.fetch;
    const originFetch = (window as any).fetch;

    window.fetch = function(input: string | Request, configs = { }) {
      let url: string = '';
      let method: string = '';
      let data: any;

      if (getType(input) === DefTypes.STRING) {
        url = input as string;
        data = configs.body;
      }

      if (getType(input) === DefTypes.REQUEST) {
        url = (input as Request).url;
        method = (input as Request).method;
        data = isEmptyObj(configs) ? (input as Request).body : configs.body;
      }

      if (!isEmptyObj(configs) && 'method' in configs) {
        method = configs.method || 'GET';
      }

      const api = formatUrl(url);
      const traceId = getTraceId(options.trace128bit);
      const pMark = checkIfNeedCollect(url, options);

      return new Promise((resolve, reject) => {
        if (pMark) {
          if (options.debug) {
            logger.info('fetch opened[url: ' + api + ', TraceId: ' + traceId + ']');
          }

          window.performance.mark(`${performanceStartPrefix}${api}`);

          // 在请求头中写入 TraceId
          let addHeaders: Record<string, string> = { };

          if (getDocOrigin() === getOrigin(url)) {
            if (options.isCoohom) {
              addHeaders = {
                [coohomHeaders.TraceId]: traceId,
                [coohomHeaders.SpanId]: traceId,
              };
            } else {
              addHeaders = {
                [qunheHeaders.TraceId]: traceId,
              };
            }
          }

          if (!isEmptyObj(addHeaders)) {
            if (getType(input) === DefTypes.REQUEST && (input as Request).headers) {
              Object.keys(addHeaders).forEach(key => {
                (input as Request).headers.append(key, addHeaders[key]);
              });
            } else {
              configs.headers = { ...configs.headers, ...addHeaders };
            }
          }
        }

        if (options.debug) {
          logger.info('fetch interceptor[url: ' + api + ', marked: ' + pMark + ']');
        }

        originFetch.apply(this, [input, configs])
          .then((response: Response) => checkStatus(response, {
            url,
            data,
            method,
            traceId,
          }))
          .then((response: Response) => {
            resolve(response);
          })
          .catch((error: Error) => {
            const { parsedStack, labels } = ErrorParser.parseStack(error, options.maxStackDepth);
            processErrorDataV2(parsedStack, options, labels);
            reject(error);
          });
      });
    };
  }
}
